import { useQuery } from 'hooks/query/useQuery'
import { useSetQuery } from 'hooks/query/useSetQuery'
import { useCallback, useMemo } from 'react'

export const useFilteredData = filters => {
  const query = useQuery()
  const setQuery = useSetQuery()
  const filteredData = useMemo(
    () =>
      Object.keys(query)
        .reduce((filterItems, key) => [...filterItems, ...getFilterItemData(key, query[key], filters)], [])
        .filter(item => item),
    [query, filters]
  )
  const clearFilterItem = useCallback(
    (key, id) => {
      if (!key) return setQuery({}, true)
      const data = query[key]?.filter(item => item != id)
      setQuery({ [key]: data })
    },
    [query, setQuery]
  )

  return useMemo(() => ({ filteredData, clearFilterItem }), [filteredData, clearFilterItem])
}

const mapFilterItemValue = (value, items) =>
  value
    .map(id => ({
      label: items.find(item => item.value == id)?.label,
      id,
    }))
    .filter(({ label }) => label)
const returnFilterKey = key => {
  switch (key) {
    case 'categories':
      return 'categoryOptions'
    case 'tags':
      return 'tagOptions'
    default:
      return key
  }
}
const getFilterItemData = (key, value, filter) => {
  const filterKey = returnFilterKey(key)
  const items = filter[filterKey]
  if (!items) return []

  return mapFilterItemValue(value, items).map(item => ({ ...item, key }))
}
